import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=0e84eddc&"
import script from "./appInfo.vue?vue&type=script&lang=js&"
export * from "./appInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e84eddc')) {
      api.createRecord('0e84eddc', component.options)
    } else {
      api.reload('0e84eddc', component.options)
    }
    module.hot.accept("./appInfo.vue?vue&type=template&id=0e84eddc&", function () {
      api.rerender('0e84eddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/appInfo.vue"
export default component.exports